import type { IDataTableNormalizedResponse, IDataTablePagination } from './types';

/**
 * Varsayılan başlangıç sayfa numarası.
 * pageIndex 0-based olduğu için bu değer 0'dır.
 */
export const DATA_TABLE_INITIAL_PAGE = 0;

/**
 * Varsayılan sayfa başına gösterilecek veri sayısı.
 */
export const DATA_TABLE_INITIAL_LIMIT = 10;

/**
 * Varsayılan pagination durumu.
 * `DataTable` `initial.pagination` ile bu objeyi birleştirir.
 * - pageIndex: 0 (0-based index)
 * - pageSize: 10 (sayfa başına 10 veri)
 */
export const DATA_TABLE_INITIAL_PAGINATION: IDataTablePagination = {
  pageIndex: DATA_TABLE_INITIAL_PAGE,
  pageSize: DATA_TABLE_INITIAL_LIMIT,
};

/**
 * @description Varsayılan veri tipi.
 * @description Bu değerleri responseAdapter fonksiyonu döndürecektir.
 * @example { items: [], totalCount: 0, itemCount: 0, pageCount: 0, currentPage: 0, limit: 0 }
 */
export const DATA_TABLE_DEFAULT_DATA: IDataTableNormalizedResponse<never> = {
  items: [],
  totalCount: 0,
  itemCount: 0,
  pageCount: 0,
  currentPage: 0,
  limit: 0,
};

export const DATA_TABLE_DEFAULT_RESPONSE_ADAPTER = (response: any): IDataTableNormalizedResponse<any> => {
  return {
    items: response?.items || [],
    totalCount: response?.totalCount || 0,
    itemCount: response?.itemCount || 0,
    pageCount: response?.pageCount || 0,
    currentPage: response?.currentPage || 0,
    limit: response?.limit || 0,
  };
};
